import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './artservices.css'; // Import the CSS file for styling

function ArtServices() {
  const images = [
    "/images/Art Services/Art Services_01.jpg",
  "/images/Art Services/Art Services_02.jpg",
  "/images/Art Services/Art Services_03.jpg",
  "/images/Art Services/Art Services_04.jpg",
  "/images/Art Services/Art Services_05.jpg",
  "/images/Art Services/Art Services_06.jpg",
  "/images/Art Services/Art Services_07.jpg",
  "/images/Art Services/Art Services_08.jpg",
  "/images/Art Services/Art Services_09.jpg",
  "/images/Art Services/Art Services_10.jpg",
  "/images/Art Services/Art Services_11.jpg",
  "/images/Art Services/Art Services_12.jpg",
  "/images/Art Services/Art Services_13.jpg",
  "/images/Art Services/Art Services_14.jpg",
  "/images/Art Services/Art Services_15.jpg",
  "/images/Art Services/Art Services_16.jpg",
  "/images/Art Services/Art Services_17.jpg",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Function to go to the next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div className="artservices-container">
      <Link to="/" className="home-button">Home</Link> {/* Home button */}
      
      <div className="image-frame">
        <div className="text-container">  
          <h2> <div className="title-gc"> Art Services </div> </h2> 
          <p><div className="text-blurb">
            Installation of all types of artwork including paintings, sculptures, and decorative objects. 
            Custom fabrication of frames, armatures, mockups, and specialty hardware, as well as implementation of custom art lighting.
         </div> </p>
        </div>

        <div className="slideshow-container">
          <img
            src={images[currentImageIndex]}
            alt={`Art Services Slide ${currentImageIndex}`}
            className="artservices-image"
          />
          {/* Navigation buttons */}
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
}

export default ArtServices;
